export default "__VITE_PUBLIC_ASSET__778eb422__"